'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

var _paths2 = require('../events/paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, adj_id, person_id, data) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      adj_id: adj_id,
      person_id: person_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.scoreByAdjudicatorUrl)(feis_id, event_id, adj_id, person_id),
        method: 'POST',
        data: data
      },
      types: ['CREATE_SCORE_START', 'CREATE_SCORE', 'CREATE_SCORE_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/scores/createScore.js
// module id = 672
// module chunks = 0